export enum PhoneCallType {
  LEAD = 'lead',
  SOURCE = 'source',
  CRITICISM = 'criticism',
  TRANSFER = 'transfer',
  OTHER = 'other',
  CANCELLED = 'CANCELLED',
}

export type BusinessProductType = {
  productName: string
  unitName: string
  quantity: number
}
export type CallCenterProductType = {
  productTypeName: string
  quantity: string
}

export type TransferHistoryType = {
  transferTime?: number
  extension?: string
  domainName?: string
  fullName?: string
  teamName?: string
  userPosition?: string
  userPositionLevel?: string
  phoneCallId?: string
  imageUrl?: string
  businessProduct?: BusinessProductType[]
  callCenterProductType?: CallCenterProductType[]
}

export type CallDataType = {
  opportunityId: string | null
  phoneCallId: string
  isHangup: boolean
  isNewCustomer: boolean
  invoiceCount: number
  quoteCount: number
  callerName: string
  phoneNumber: string
  phoneNumbers: string[]
  source?: string
  accountName: string
  contactName: string
  leadName: string
  startDate: string | null
  isVIP: boolean
  accountId?: string
  contactId?: string
  leadId?: string
  lastExpertTalked?: {
    fullName?: string
    imageUrl?: string
    teamName?: string
    userPosition?: string
  }
  preName?: {
    value?: number
    label?: string
  }
  transferHistory?: TransferHistoryType[]
  companyName?: string
  leadSource?: {
    label?: string
    value?: number
  }
}

export type RingingDataType = {
  phoneCallId: string
  isNewCustomer: boolean
  invoiceCount: number
  quoteCount: number
  callerName: string
  phoneNumber: string
  accountName: string
  contactName: string
  leadName: string
  isVIP: boolean
  preName?: {
    value?: number
    label?: string
  }
}

export default class OperatorExtension {
  id: string
  userExtension: string
  isBusy: string
  userDomain: string
  fullName: string
  productTypes: string[]
  userPosition: string
  teamName: string
  userPositionLevel: string
  imageUrl: string
  searchName: string
  transferRate?: number

  constructor(operator: OperatorExtension) {
    this.id = operator.id
    this.userExtension = operator.userExtension
    this.isBusy = operator.isBusy
    this.userDomain = operator.userDomain
    this.fullName = operator.fullName
    this.productTypes = operator.productTypes
    this.userPosition = operator.userPosition
    this.teamName = operator.teamName
    this.userPositionLevel = operator.userPositionLevel
    this.imageUrl = operator.imageUrl
    this.searchName = operator.fullName.replaceAll('آ', 'ا')
    this.transferRate = operator.transferRate
  }
}

export type SelectedCustomerType = {
  type: 'lead' | 'account' | 'contact'
  id: string
  name: string
  companyName?: string
}

export type FormDataType = {
  preName?: number
  leadName?: string
  leadId?: string
  preLeadName?: number
  callType: PhoneCallType
  newLeadName: string
  leadSource: number
  description: string
  selectedCustomer?: SelectedCustomerType
  selectedProductTypes: SelectedProductTypeType[]
  selectedOperator: OperatorExtension | null
  transferredBusinessUnit: string
  topic?: string
  isOverload?: boolean
  isCooperationRequest?: boolean
}

export type SelectedProductTypeType = {
  id: string
  name: string
  requestedQuantity: string
  isNew: boolean
}

export type SetCallDataPayloadType = {
  opportunityId: string | null
  accountId: string
  contactId: string
  leadId: string
  phoneCallId: string
  accountName: string
  contactName: string
  leadName: string
  callerName: string
  invoiceCount: number
  quoteCount: number
  isNewCustomer: boolean
  phoneNumber: string
  phoneNumbers: string[]
  isVIP: boolean
  preName?: {
    value?: number
    label?: string
  }
}
